/* tslint:disable */
/* eslint-disable */
/**
 * SUREnet vragen-public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CollectionResultOfVragenDomainHoedanighedenSbi2025Code
 */
export interface CollectionResultOfVragenDomainHoedanighedenSbi2025Code {
    /**
     * 
     * @type {Array<VragenDomainHoedanighedenSbi2025Code>}
     * @memberof CollectionResultOfVragenDomainHoedanighedenSbi2025Code
     */
    result: Array<VragenDomainHoedanighedenSbi2025Code>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto
 */
export interface CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto {
    /**
     * 
     * @type {Array<VragenHoedanighedenGetHoedanighedenHoedanigheidDto>}
     * @memberof CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto
     */
    result: Array<VragenHoedanighedenGetHoedanighedenHoedanigheidDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto
 */
export interface CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto {
    /**
     * 
     * @type {Array<VragenOfferteAntwoordenSetsGetAntwoordensetsDto>}
     * @memberof CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    result: Array<VragenOfferteAntwoordenSetsGetAntwoordensetsDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto
 */
export interface CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto {
    /**
     * 
     * @type {Array<VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto>}
     * @memberof CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto
     */
    result: Array<VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto
 */
export interface CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto {
    /**
     * 
     * @type {Array<VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto>}
     * @memberof CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto
     */
    result: Array<VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto
 */
export interface CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto {
    /**
     * 
     * @type {Array<VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto>}
     * @memberof CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto
     */
    result: Array<VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto
 */
export interface CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto {
    /**
     * 
     * @type {Array<VragenProductVragenGetProductVragenProductVraagDto>}
     * @memberof CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto
     */
    result: Array<VragenProductVragenGetProductVragenProductVraagDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto
 */
export interface CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto {
    /**
     * 
     * @type {Array<VragenProductVragenProductVraagGroepenProductVraaggroepDto>}
     * @memberof CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto
     */
    result: Array<VragenProductVragenProductVraagGroepenProductVraaggroepDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto
 */
export interface CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto {
    /**
     * 
     * @type {Array<VragenRisicoscansGetRecenteRisicoscansDto>}
     * @memberof CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto
     */
    result: Array<VragenRisicoscansGetRecenteRisicoscansDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenSbiCodesSbiCodeDto
 */
export interface CollectionResultOfVragenSbiCodesSbiCodeDto {
    /**
     * 
     * @type {Array<VragenSbiCodesSbiCodeDto>}
     * @memberof CollectionResultOfVragenSbiCodesSbiCodeDto
     */
    result: Array<VragenSbiCodesSbiCodeDto>;
}
/**
 * 
 * @export
 * @interface CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto
 */
export interface CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto {
    /**
     * 
     * @type {Array<VragenVraagVeldMappingsGetVraagVeldMappingsDto>}
     * @memberof CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto
     */
    result: Array<VragenVraagVeldMappingsGetVraagVeldMappingsDto>;
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails
 */
export interface MicrosoftAspNetCoreHttpHttpValidationProblemDetails extends MicrosoftAspNetCoreMvcProblemDetails {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof MicrosoftAspNetCoreHttpHttpValidationProblemDetails
     */
    errors: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface MicrosoftAspNetCoreMvcProblemDetails
 */
export interface MicrosoftAspNetCoreMvcProblemDetails {
    [key: string]: any | any;

    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    typeName: string;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftAspNetCoreMvcProblemDetails
     */
    instance?: string | null;
}
/**
 * 
 * @export
 * @interface Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto
 */
export interface Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto {
    /**
     * 
     * @type {{ [key: string]: Array<VragenAntwoordOptiesAntwoordOptieDto>; }}
     * @memberof Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto
     */
    result: { [key: string]: Array<VragenAntwoordOptiesAntwoordOptieDto>; } | null;
}
/**
 * 
 * @export
 * @interface Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString
 */
export interface Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString
     */
    result: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface Result1OfVragenControleregelsVoerControleregelsUitDto
 */
export interface Result1OfVragenControleregelsVoerControleregelsUitDto {
    /**
     * 
     * @type {VragenControleregelsVoerControleregelsUitDto}
     * @memberof Result1OfVragenControleregelsVoerControleregelsUitDto
     */
    result: VragenControleregelsVoerControleregelsUitDto;
}
/**
 * 
 * @export
 * @interface Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto
 */
export interface Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto {
    /**
     * 
     * @type {VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto}
     * @memberof Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto
     */
    result: VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto;
}
/**
 * 
 * @export
 * @interface Result1OfVragenOfferteGetAntwoordensetStatusDto
 */
export interface Result1OfVragenOfferteGetAntwoordensetStatusDto {
    /**
     * 
     * @type {VragenOfferteGetAntwoordensetStatusDto}
     * @memberof Result1OfVragenOfferteGetAntwoordensetStatusDto
     */
    result: VragenOfferteGetAntwoordensetStatusDto;
}
/**
 * 
 * @export
 * @interface Result1OfVragenOfferteGetMeldcodeResponse
 */
export interface Result1OfVragenOfferteGetMeldcodeResponse {
    /**
     * 
     * @type {VragenOfferteGetMeldcodeResponse}
     * @memberof Result1OfVragenOfferteGetMeldcodeResponse
     */
    result: VragenOfferteGetMeldcodeResponse;
}
/**
 * 
 * @export
 * @interface Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse
 */
export interface Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse {
    /**
     * 
     * @type {VragenOfferteHaalMeldcodeOpVoorOfferteproductResponse}
     * @memberof Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse
     */
    result: VragenOfferteHaalMeldcodeOpVoorOfferteproductResponse;
}
/**
 * 
 * @export
 * @interface Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto
 */
export interface Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordAntwoordenSetDto}
     * @memberof Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto
     */
    result: VragenOfferteVraagAntwoordAntwoordenSetDto;
}
/**
 * 
 * @export
 * @interface Result1OfVragenSbiCodesSbiBeschrijvingDto
 */
export interface Result1OfVragenSbiCodesSbiBeschrijvingDto {
    /**
     * 
     * @type {VragenSbiCodesSbiBeschrijvingDto}
     * @memberof Result1OfVragenSbiCodesSbiBeschrijvingDto
     */
    result: VragenSbiCodesSbiBeschrijvingDto;
}
/**
 * 
 * @export
 * @interface SUREbusinessCommonDomainValueObjectsAdres
 */
export interface SUREbusinessCommonDomainValueObjectsAdres {
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    postcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    plaats?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    straat?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    huisnummer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsAdres
     */
    huisnummertoevoeging?: string | null;
}
/**
 * 
 * @export
 * @interface SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
 */
export interface SUREbusinessCommonDomainValueObjectsGerelateerdeAdres {
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    plaats: string;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    straat: string;
    /**
     * 
     * @type {number}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    huisnummer: number;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    huisnummertoevoeging?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SUREbusinessCommonDomainValueObjectsGerelateerdeAdres
     */
    nummerAanduidingId: string;
}
/**
 * 
 * @export
 * @interface VragenAntwoordOptiesAntwoordOptieDto
 */
export interface VragenAntwoordOptiesAntwoordOptieDto {
    /**
     * 
     * @type {string}
     * @memberof VragenAntwoordOptiesAntwoordOptieDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof VragenAntwoordOptiesAntwoordOptieDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof VragenAntwoordOptiesAntwoordOptieDto
     */
    groep?: string | null;
}
/**
 * 
 * @export
 * @interface VragenControleregelsVoerControleregelsUitDto
 */
export interface VragenControleregelsVoerControleregelsUitDto {
    /**
     * 
     * @type {boolean}
     * @memberof VragenControleregelsVoerControleregelsUitDto
     */
    geslaagd: boolean;
    /**
     * 
     * @type {Array<VragenControleregelsVoerControleregelsUitProductDto>}
     * @memberof VragenControleregelsVoerControleregelsUitDto
     */
    producten: Array<VragenControleregelsVoerControleregelsUitProductDto>;
}
/**
 * 
 * @export
 * @interface VragenControleregelsVoerControleregelsUitMeldingDto
 */
export interface VragenControleregelsVoerControleregelsUitMeldingDto {
    /**
     * 
     * @type {number}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    controleregelId: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    vraagIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    melding: string;
    /**
     * 
     * @type {VragenDomainControleregelsAcceptatieCode}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    gradatie: VragenDomainControleregelsAcceptatieCode;
    /**
     * 
     * @type {string}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    productmaatschappijId: string;
    /**
     * 
     * @type {boolean}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    meldingTonenBijPremieInOfferte: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    meldingTonenInWinkelmand: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    meldingIntern?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VragenControleregelsVoerControleregelsUitMeldingDto
     */
    offerteproductId?: number | null;
}
/**
 * 
 * @export
 * @interface VragenControleregelsVoerControleregelsUitProductDto
 */
export interface VragenControleregelsVoerControleregelsUitProductDto {
    /**
     * 
     * @type {number}
     * @memberof VragenControleregelsVoerControleregelsUitProductDto
     */
    offerteproductId: number;
    /**
     * 
     * @type {Array<VragenControleregelsVoerControleregelsUitMeldingDto>}
     * @memberof VragenControleregelsVoerControleregelsUitProductDto
     */
    meldingen: Array<VragenControleregelsVoerControleregelsUitMeldingDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VragenControleregelsVoerControleregelsUitProductDto
     */
    debugMeldingen: Array<string>;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenAdresAntwoord
 */
export interface VragenDomainAntwoordenAdresAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {SUREbusinessCommonDomainValueObjectsAdres}
     * @memberof VragenDomainAntwoordenAdresAntwoord
     */
    value: SUREbusinessCommonDomainValueObjectsAdres;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenAdresAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenAntwoord
 */
export interface VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainAntwoordenAntwoordType {
    StringAntwoord = 'StringAntwoord',
    MultipleStringAntwoord = 'MultipleStringAntwoord',
    NummerAntwoord = 'NummerAntwoord',
    DecimaalAntwoord = 'DecimaalAntwoord',
    AdresAntwoord = 'AdresAntwoord',
    SchadeverledenAntwoord = 'SchadeverledenAntwoord',
    GeenAntwoord = 'GeenAntwoord',
    GerelateerdeAdresAntwoord = 'GerelateerdeAdresAntwoord',
    WagenparkAntwoord = 'WagenparkAntwoord',
    MatrixAntwoord = 'MatrixAntwoord',
    VerzekerdenAntwoord = 'VerzekerdenAntwoord',
    VerzekerdenVolledigAntwoord = 'VerzekerdenVolledigAntwoord'
}

/**
 * 
 * @export
 * @interface VragenDomainAntwoordenDecimaalAntwoord
 */
export interface VragenDomainAntwoordenDecimaalAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {number}
     * @memberof VragenDomainAntwoordenDecimaalAntwoord
     */
    value: number;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenDecimaalAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenGerelateerdeAdressenAntwoord
 */
export interface VragenDomainAntwoordenGerelateerdeAdressenAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<SUREbusinessCommonDomainValueObjectsGerelateerdeAdres>}
     * @memberof VragenDomainAntwoordenGerelateerdeAdressenAntwoord
     */
    value: Array<SUREbusinessCommonDomainValueObjectsGerelateerdeAdres>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenGerelateerdeAdressenAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenMatrixAntwoord
 */
export interface VragenDomainAntwoordenMatrixAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<VragenDomainAntwoordenMatrixEntry>}
     * @memberof VragenDomainAntwoordenMatrixAntwoord
     */
    value: Array<VragenDomainAntwoordenMatrixEntry>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenMatrixAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenMatrixEntry
 */
export interface VragenDomainAntwoordenMatrixEntry {
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenMatrixEntry
     */
    rijCode: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenMatrixEntry
     */
    kolomCode: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenMatrixEntry
     */
    waarde: string;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenMultipleStringAntwoord
 */
export interface VragenDomainAntwoordenMultipleStringAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<string>}
     * @memberof VragenDomainAntwoordenMultipleStringAntwoord
     */
    value: Array<string>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenMultipleStringAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenNullAntwoord
 */
export interface VragenDomainAntwoordenNullAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenNullAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenNummerAntwoord
 */
export interface VragenDomainAntwoordenNummerAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {number}
     * @memberof VragenDomainAntwoordenNummerAntwoord
     */
    value: number;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenNummerAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainAntwoordenRelatieMetVerzekeringnemer {
    Hoofdverzekerde = 'A',
    Partner = 'T',
    Kind = 'C'
}

/**
 * 
 * @export
 * @interface VragenDomainAntwoordenSchadeverleden
 */
export interface VragenDomainAntwoordenSchadeverleden {
    /**
     * 
     * @type {number}
     * @memberof VragenDomainAntwoordenSchadeverleden
     */
    jaar: number;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenSchadeverleden
     */
    soortSchade: string;
    /**
     * 
     * @type {VragenDomainAntwoordenSchuldschade}
     * @memberof VragenDomainAntwoordenSchadeverleden
     */
    schuldschade: VragenDomainAntwoordenSchuldschade;
    /**
     * 
     * @type {number}
     * @memberof VragenDomainAntwoordenSchadeverleden
     */
    bedrag?: number | null;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenSchadeverledenAntwoord
 */
export interface VragenDomainAntwoordenSchadeverledenAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<VragenDomainAntwoordenSchadeverleden>}
     * @memberof VragenDomainAntwoordenSchadeverledenAntwoord
     */
    value: Array<VragenDomainAntwoordenSchadeverleden>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenSchadeverledenAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainAntwoordenSchuldschade {
    Nvt = 'Nvt',
    Ja = 'Ja',
    Nee = 'Nee'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainAntwoordenSetsPremievraagantwoordenstatus {
    Onbekend = 'Onbekend',
    Nieuw = 'Nieuw',
    Concept = 'Concept',
    Definitief = 'Definitief'
}

/**
 * 
 * @export
 * @interface VragenDomainAntwoordenStringAntwoord
 */
export interface VragenDomainAntwoordenStringAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenStringAntwoord
     */
    value: string;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenStringAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenVerzekerde
 */
export interface VragenDomainAntwoordenVerzekerde {
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenVerzekerde
     */
    geboortedatum: string;
    /**
     * 
     * @type {VragenDomainAntwoordenRelatieMetVerzekeringnemer}
     * @memberof VragenDomainAntwoordenVerzekerde
     */
    relatieMetVerzekeringnemer: VragenDomainAntwoordenRelatieMetVerzekeringnemer;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenVerzekerdeVolledig
 */
export interface VragenDomainAntwoordenVerzekerdeVolledig {
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenVerzekerdeVolledig
     */
    voorletters: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenVerzekerdeVolledig
     */
    tussenvoegsel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenVerzekerdeVolledig
     */
    achternaam: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenVerzekerdeVolledig
     */
    geboortedatum: string;
    /**
     * 
     * @type {VragenDomainAntwoordenRelatieMetVerzekeringnemer}
     * @memberof VragenDomainAntwoordenVerzekerdeVolledig
     */
    relatieMetVerzekeringnemer: VragenDomainAntwoordenRelatieMetVerzekeringnemer;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenVerzekerdenAntwoord
 */
export interface VragenDomainAntwoordenVerzekerdenAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<VragenDomainAntwoordenVerzekerde>}
     * @memberof VragenDomainAntwoordenVerzekerdenAntwoord
     */
    value: Array<VragenDomainAntwoordenVerzekerde>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenVerzekerdenAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenVerzekerdenVolledigAntwoord
 */
export interface VragenDomainAntwoordenVerzekerdenVolledigAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {Array<VragenDomainAntwoordenVerzekerdeVolledig>}
     * @memberof VragenDomainAntwoordenVerzekerdenVolledigAntwoord
     */
    value: Array<VragenDomainAntwoordenVerzekerdeVolledig>;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenVerzekerdenVolledigAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenDomainAntwoordenWagenparkAntwoord
 */
export interface VragenDomainAntwoordenWagenparkAntwoord extends VragenDomainAntwoordenAntwoord {
    /**
     * 
     * @type {string}
     * @memberof VragenDomainAntwoordenWagenparkAntwoord
     */
    value: string;
    /**
     * 
     * @type {VragenDomainAntwoordenAntwoordType}
     * @memberof VragenDomainAntwoordenWagenparkAntwoord
     */
    typeName: VragenDomainAntwoordenAntwoordType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainBetreftVraag {
    None = 'None',
    Aanhanger = 'Aanhanger',
    Acceleratie = 'Acceleratie',
    Bouwjaar = 'Bouwjaar',
    BouwjaarDatum = 'Bouwjaar_datum',
    Datumoprichtingbedrijf = 'Datumoprichtingbedrijf',
    Herbouwwaarde = 'Herbouwwaarde',
    Kenteken = 'Kenteken',
    KentekenAanwezig = 'Kenteken_aanwezig',
    Kvknummer = 'Kvknummer',
    Meldcode = 'Meldcode',
    Merk = 'Merk',
    Mrdekking = 'Mrdekking',
    Rechtsvorm = 'Rechtsvorm',
    Sbbranche = 'Sbbranche',
    Sbhoedanigheid = 'Sbhoedanigheid',
    Sbiopzoek2 = 'Sbiopzoek2',
    Schadevrijejaren = 'Schadevrijejaren',
    Soorteigenaar = 'Soorteigenaar',
    Type = 'Type',
    Voertuigaandrijving = 'Voertuigaandrijving',
    Voertuigaantaldeuren = 'Voertuigaantaldeuren',
    Voertuigafdcode = 'Voertuigafdcode',
    Voertuigbouwdag = 'Voertuigbouwdag',
    Voertuigbouwdatum = 'Voertuigbouwdatum',
    Voertuigbouwjaar = 'Voertuigbouwjaar',
    Voertuigbouwmaand = 'Voertuigbouwmaand',
    Voertuigbrandstof = 'Voertuigbrandstof',
    Voertuigbrandstof2 = 'Voertuigbrandstof2',
    Voertuigcarrosserie = 'Voertuigcarrosserie',
    Voertuigcatwaarde = 'Voertuigcatwaarde',
    Voertuigcilinderinho = 'Voertuigcilinderinho',
    Voertuigdagwaarde = 'Voertuigdagwaarde',
    Voertuigdatumafgifte = 'Voertuigdatumafgifte',
    Voertuiggewicht = 'Voertuiggewicht',
    Voertuiggewichtopl = 'Voertuiggewichtopl',
    Voertuigkleur = 'Voertuigkleur',
    Voertuiglaadvermogen = 'Voertuiglaadvermogen',
    Voertuigmaxmassa = 'Voertuigmaxmassa',
    Voertuigmerk = 'Voertuigmerk',
    Voertuigmodel = 'Voertuigmodel',
    Voertuigrdwinrichtin = 'Voertuigrdwinrichtin',
    Voertuigsoortvoertui = 'Voertuigsoortvoertui',
    Voertuigtenaamrecent = 'Voertuigtenaamrecent',
    Voertuigtransmissie = 'Voertuigtransmissie',
    Voertuigtypevoertuig = 'Voertuigtypevoertuig',
    Voertuigvermogen = 'Voertuigvermogen',
    Makelaarswijziging = 'Makelaarswijziging',
    MakelaarswijzigingDatum = 'MakelaarswijzigingDatum',
    MakelaarswijzigingPolisnummer = 'MakelaarswijzigingPolisnummer',
    MakelaarswijzigingVnabnummer = 'MakelaarswijzigingVnabnummer',
    MakelaarswijzigingHuidigeMakelaar = 'MakelaarswijzigingHuidigeMakelaar',
    VoertuigCatwaardeExBtw = 'VoertuigCatwaardeExBtw',
    SchadeverzekeringInzittenden = 'SchadeverzekeringInzittenden',
    RechtsbijstandMotorrijtuigen = 'RechtsbijstandMotorrijtuigen',
    EigenRisico = 'EigenRisico',
    Waardebepaling = 'Waardebepaling',
    WaardebepalingDatum = 'WaardebepalingDatum',
    InExBtw = 'InExBtw',
    EenGebouw = 'EenGebouw',
    ParkeergarageAanwezig = 'ParkeergarageAanwezig',
    KelderAanwezig = 'KelderAanwezig',
    TypeWoning = 'TypeWoning',
    BouwaardMuren = 'BouwaardMuren',
    Dakbedekking = 'Dakbedekking',
    Dakconstructie = 'Dakconstructie',
    Monumentsoort = 'Monumentsoort',
    WozWaarde = 'WozWaarde',
    InhoudKubiekeMeters = 'InhoudKubiekeMeters',
    OppervlakteVierkanteMeters = 'OppervlakteVierkanteMeters',
    OppervlakteBijgebouwenVierkanteMeters = 'OppervlakteBijgebouwenVierkanteMeters'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainControleregelsAcceptatieCode {
    Waarschuwing = 'Waarschuwing',
    NietMogelijk = 'NietMogelijk',
    TerAcceptatie = 'TerAcceptatie',
    GeenPremie = 'GeenPremie',
    NietTonenInVergelijking = 'NietTonenInVergelijking',
    Maatwerk = 'Maatwerk'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainFilterSoort {
    Of = 'Of',
    En = 'En',
    Null = 'Null'
}

/**
 * 
 * @export
 * @interface VragenDomainHoedanighedenSbi2025Code
 */
export interface VragenDomainHoedanighedenSbi2025Code {
    /**
     * 
     * @type {number}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    codeGestript: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    codeCcs: string;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    omschrijving: string;
    /**
     * 
     * @type {boolean}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    hasChildren: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenDomainHoedanighedenSbi2025Code
     */
    codeParent: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainMatrixDimensieSoort {
    Rij = 'Rij',
    Kolom = 'Kolom'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainOfferteDetailSoort {
    PremieVragen = 'PremieVragen',
    PremieVragenOud = 'PremieVragen_Oud',
    PremieVragenDraft = 'PremieVragen_Draft',
    PremieVragenGesteld = 'PremieVragen_Gesteld',
    PtsAanvraagVragenDraft = 'PtsAanvraagVragen_Draft',
    PtsAanvraagVragen = 'PtsAanvraagVragen',
    PtsAcceptatieVragenDraft = 'PtsAcceptatieVragen_Draft',
    PtsAcceptatieVragen = 'PtsAcceptatieVragen',
    MaatwerkVragenDraft = 'MaatwerkVragen_Draft',
    MaatwerkVragen = 'MaatwerkVragen',
    PremievaststellingsVragen = 'PremievaststellingsVragen',
    PremievaststellingsVragenDraft = 'PremievaststellingsVragen_Draft',
    SlotvragenV2 = 'SlotvragenV2',
    SlotvragenV2Draft = 'SlotvragenV2_Draft',
    VoorlopigedekkingVragen = 'VoorlopigedekkingVragen',
    VoorlopigedekkingVragenDraft = 'VoorlopigedekkingVragen_Draft',
    PremieVragenOrigineel = 'PremieVragen_Origineel'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainOperatorEnum {
    None = 'None',
    BegintMet = 'BegintMet',
    BevatTekst = 'BevatTekst',
    GelijkAan = 'GelijkAan',
    GroterDan = 'GroterDan',
    KleinerDan = 'KleinerDan',
    OngelijkAan = 'OngelijkAan'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainProductHoedanigHeidGradatieEnum {
    V = 'V',
    X = 'X',
    M = 'M',
    A = 'A'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainProductVraagStatus {
    Actief = 'Actief',
    Inactief = 'Inactief',
    Test = 'Test',
    Verwijderd = 'Verwijderd'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainVraagSoort {
    None = 'None',
    AcceptatieVraag = 'AcceptatieVraag',
    AcceptatieVraagOrigineel = 'AcceptatieVraagOrigineel',
    PremieVraag = 'PremieVraag',
    PremieVraagOrigineel = 'PremieVraagOrigineel',
    PtsAanvraagVraag = 'PtsAanvraagVraag',
    PtsAcceptatieVraag = 'PtsAcceptatieVraag',
    MaatwerkVraag = 'MaatwerkVraag',
    PremievaststellingsVraag = 'PremievaststellingsVraag',
    SlotVraag = 'SlotVraag',
    VoorlopigedekkingVraag = 'VoorlopigedekkingVraag'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainVraagType {
    None = 'None',
    AlgemeneTabel = 'AlgemeneTabel',
    BerekendVeld = 'BerekendVeld',
    Datum = 'Datum',
    Decimaal = 'Decimaal',
    JaNee = 'JaNee',
    Kenteken = 'Kenteken',
    KeuzeRondjes = 'KeuzeRondjes',
    KvkNummer = 'KvkNummer',
    Labeltje = 'Labeltje',
    Numeriek = 'Numeriek',
    PostCode = 'PostCode',
    RisicoAdres = 'RisicoAdres',
    SbHoedanigheid = 'SbHoedanigheid',
    SbiOpzoek2 = 'SbiOpzoek2',
    Tabel = 'Tabel',
    Tekst = 'Tekst',
    TekstArea = 'TekstArea',
    Valuta = 'Valuta',
    BsnNummer = 'BsnNummer',
    DatumTijd = 'DatumTijd',
    Document = 'Document',
    Rechtspersoon = 'Rechtspersoon',
    Schadeverleden = 'Schadeverleden',
    Meldcode = 'Meldcode',
    GerelateerdeAdressen = 'GerelateerdeAdressen',
    Wagenpark = 'Wagenpark',
    Matrix = 'Matrix',
    Verzekerden = 'Verzekerden',
    VerzekerdenVolledig = 'VerzekerdenVolledig'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenDomainVraagVeldMappingSoort {
    WaardebepalingRequest = 'WaardebepalingRequest',
    WaardebepalingResponse = 'WaardebepalingResponse'
}

/**
 * 
 * @export
 * @interface VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto
 */
export interface VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto {
    /**
     * 
     * @type {Array<VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto>}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto
     */
    meldingen: Array<VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto>;
    /**
     * 
     * @type {boolean}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto
     */
    isGeslaagd: boolean;
}
/**
 * 
 * @export
 * @interface VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto
 */
export interface VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto {
    /**
     * 
     * @type {string}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto
     */
    productmaatschappijId?: string | null;
    /**
     * 
     * @type {VragenDomainProductHoedanigHeidGradatieEnum}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto
     */
    gradatie: VragenDomainProductHoedanigHeidGradatieEnum;
    /**
     * 
     * @type {string}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto
     */
    melding: string;
    /**
     * 
     * @type {string}
     * @memberof VragenHoedanighedenControlerenVoerHoedanigheidControlesUitMeldingDto
     */
    vraagId: string;
}
/**
 * 
 * @export
 * @interface VragenHoedanighedenGetHoedanighedenHoedanigheidDto
 */
export interface VragenHoedanighedenGetHoedanighedenHoedanigheidDto {
    /**
     * 
     * @type {string}
     * @memberof VragenHoedanighedenGetHoedanighedenHoedanigheidDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenHoedanighedenGetHoedanighedenHoedanigheidDto
     */
    omschrijving: string;
    /**
     * 
     * @type {number}
     * @memberof VragenHoedanighedenGetHoedanighedenHoedanigheidDto
     */
    brancheCode: number;
}
/**
 * 
 * @export
 * @interface VragenOfferteAntwoordenSetsGetAntwoordensetsDto
 */
export interface VragenOfferteAntwoordenSetsGetAntwoordensetsDto {
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    antwoordensetId: string;
    /**
     * 
     * @type {VragenDomainVraagSoort}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    soort: VragenDomainVraagSoort;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    offertenummer: string;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    offerteProductId?: number | null;
    /**
     * 
     * @type {VragenDomainAntwoordenSetsPremievraagantwoordenstatus}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    status: VragenDomainAntwoordenSetsPremievraagantwoordenstatus;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteAntwoordenSetsGetAntwoordensetsDto
     */
    shortLabel: string;
}
/**
 * 
 * @export
 * @interface VragenOfferteGetAntwoordensetStatusDto
 */
export interface VragenOfferteGetAntwoordensetStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof VragenOfferteGetAntwoordensetStatusDto
     */
    isCompleet: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteGetAntwoordensetStatusDto
     */
    errorMessage: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof VragenOfferteGetAntwoordensetStatusDto
     */
    errors?: { [key: string]: Array<string>; } | null;
}
/**
 * 
 * @export
 * @interface VragenOfferteGetMeldcodeResponse
 */
export interface VragenOfferteGetMeldcodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VragenOfferteGetMeldcodeResponse
     */
    vanToepassing: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteGetMeldcodeResponse
     */
    meldcode?: string | null;
}
/**
 * 
 * @export
 * @interface VragenOfferteHaalMeldcodeOpVoorOfferteproductResponse
 */
export interface VragenOfferteHaalMeldcodeOpVoorOfferteproductResponse {
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteHaalMeldcodeOpVoorOfferteproductResponse
     */
    meldcode: string;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordAntwoordenSetDto
 */
export interface VragenOfferteVraagAntwoordAntwoordenSetDto {
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordAntwoordenSetDto
     */
    antwoordensetId: string;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordAntwoordenSetDto
     */
    offertenummer: string;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteVraagAntwoordAntwoordenSetDto
     */
    offerteProductId?: number | null;
    /**
     * 
     * @type {Array<VragenOfferteVraagAntwoordVraagAntwoordStringDto | VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto | VragenOfferteVraagAntwoordVraagAntwoordIntegerDto | VragenOfferteVraagAntwoordVraagAntwoordDecimalDto | VragenOfferteVraagAntwoordVraagAntwoordAdresDto | VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto | VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto | VragenOfferteVraagAntwoordVraagAntwoordNullDto | VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto | VragenOfferteVraagAntwoordVraagAntwoordMatrixDto>}
     * @memberof VragenOfferteVraagAntwoordAntwoordenSetDto
     */
    antwoorden: Array<VragenOfferteVraagAntwoordVraagAntwoordStringDto | VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto | VragenOfferteVraagAntwoordVraagAntwoordIntegerDto | VragenOfferteVraagAntwoordVraagAntwoordDecimalDto | VragenOfferteVraagAntwoordVraagAntwoordAdresDto | VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto | VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto | VragenOfferteVraagAntwoordVraagAntwoordNullDto | VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto | VragenOfferteVraagAntwoordVraagAntwoordMatrixDto>;
    /**
     * 
     * @type {VragenDomainAntwoordenSetsPremievraagantwoordenstatus}
     * @memberof VragenOfferteVraagAntwoordAntwoordenSetDto
     */
    status: VragenDomainAntwoordenSetsPremievraagantwoordenstatus;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
 */
export interface VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto {
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    vraagId: string;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    volgorde: number;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    tekst: string;
    /**
     * 
     * @type {VragenDomainVraagType}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    type: VragenDomainVraagType;
    /**
     * 
     * @type {VragenDomainBetreftVraag}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    betreftVraag?: VragenDomainBetreftVraag;
    /**
     * 
     * @type {boolean}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto
     */
    readOnlyBijPremievaststelling: boolean;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
 */
export interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto {
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    vraagId: string;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    tekst: string;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    infotekst?: string | null;
    /**
     * 
     * @type {VragenDomainVraagSoort}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    vraagSoort: VragenDomainVraagSoort;
    /**
     * 
     * @type {VragenDomainVraagType}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    vraagType: VragenDomainVraagType;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    volgorde?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    verplicht: boolean;
    /**
     * 
     * @type {VragenDomainProductVraagStatus}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    status: VragenDomainProductVraagStatus;
    /**
     * 
     * @type {VragenDomainBetreftVraag}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    betreftVraag?: VragenDomainBetreftVraag;
    /**
     * 
     * @type {Array<VragenAntwoordOptiesAntwoordOptieDto>}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    mogelijkeAntwoorden: Array<VragenAntwoordOptiesAntwoordOptieDto>;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    productVraagId: number;
    /**
     * 
     * @type {boolean}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto
     */
    readOnlyBijPremievaststelling: boolean;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto
 */
export interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto
     */
    vraag: VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagDto;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordVraagAntwoordStringDto | VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto | VragenOfferteVraagAntwoordVraagAntwoordIntegerDto | VragenOfferteVraagAntwoordVraagAntwoordDecimalDto | VragenOfferteVraagAntwoordVraagAntwoordAdresDto | VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto | VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto | VragenOfferteVraagAntwoordVraagAntwoordNullDto | VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto | VragenOfferteVraagAntwoordVraagAntwoordMatrixDto}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto
     */
    antwoord?: VragenOfferteVraagAntwoordVraagAntwoordStringDto | VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto | VragenOfferteVraagAntwoordVraagAntwoordIntegerDto | VragenOfferteVraagAntwoordVraagAntwoordDecimalDto | VragenOfferteVraagAntwoordVraagAntwoordAdresDto | VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto | VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto | VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto | VragenOfferteVraagAntwoordVraagAntwoordNullDto | VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto | VragenOfferteVraagAntwoordVraagAntwoordMatrixDto | null;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto
 */
export interface VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto
     */
    vraag: VragenOfferteVraagAntwoordGetVragenMetAntwoordSimpleVraagDto;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto
     */
    antwoord: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenOfferteVraagAntwoordPremieVraagAntwoordType {
    AntwoordTypeString = 'AntwoordTypeString',
    AntwoordMultipleString = 'AntwoordMultipleString',
    AntwoordTypeInteger = 'AntwoordTypeInteger',
    AntwoordTypeDecimal = 'AntwoordTypeDecimal',
    AntwoordTypeAdres = 'AntwoordTypeAdres',
    AntwoordTypeSchadeverleden = 'AntwoordTypeSchadeverleden',
    AntwoordTypeNull = 'AntwoordTypeNull',
    AntwoordTypeGerelateerdeAdressen = 'AntwoordTypeGerelateerdeAdressen',
    AntwoordTypeWagenpark = 'AntwoordTypeWagenpark',
    AntwoordTypeMatrix = 'AntwoordTypeMatrix',
    AntwoordTypeVerzekerden = 'AntwoordTypeVerzekerden',
    AntwoordTypeVerzekerdenVolledig = 'AntwoordTypeVerzekerdenVolledig'
}

/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordAdresDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordAdresDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenAdresAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordAdresDto
     */
    antwoord: VragenDomainAntwoordenAdresAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordAdresDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum VragenOfferteVraagAntwoordVraagAntwoordCategorie {
    Ingevuld = 'Ingevuld',
    Afgeleid = 'Afgeleid',
    Default = 'Default',
    OmgekeerdGemapped = 'OmgekeerdGemapped'
}

/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordDecimalDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordDecimalDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDecimalDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
    /**
     * 
     * @type {VragenDomainAntwoordenDecimaalAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDecimalDto
     */
    antwoord: VragenDomainAntwoordenDecimaalAntwoord;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
    /**
     * 
     * @type {number}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDto
     */
    offerteDetailId?: number | null;
    /**
     * 
     * @type {VragenDomainOfferteDetailSoort}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDto
     */
    soort: VragenDomainOfferteDetailSoort;
    /**
     * 
     * @type {string}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDto
     */
    vraagId: string;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordVraagAntwoordCategorie}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordDto
     */
    categorie: VragenOfferteVraagAntwoordVraagAntwoordCategorie;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenGerelateerdeAdressenAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto
     */
    antwoord: VragenDomainAntwoordenGerelateerdeAdressenAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordGerelateerdeAdressenDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordIntegerDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordIntegerDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordIntegerDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
    /**
     * 
     * @type {VragenDomainAntwoordenNummerAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordIntegerDto
     */
    antwoord: VragenDomainAntwoordenNummerAntwoord;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordMatrixDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordMatrixDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenMatrixAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordMatrixDto
     */
    antwoord: VragenDomainAntwoordenMatrixAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordMatrixDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
    /**
     * 
     * @type {VragenDomainAntwoordenMultipleStringAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordMultipleStringDto
     */
    antwoord: VragenDomainAntwoordenMultipleStringAntwoord;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordNullDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordNullDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordNullDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenSchadeverledenAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto
     */
    antwoord: VragenDomainAntwoordenSchadeverledenAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordSchadeverledenDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordStringDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordStringDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordStringDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
    /**
     * 
     * @type {VragenDomainAntwoordenStringAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordStringDto
     */
    antwoord: VragenDomainAntwoordenStringAntwoord;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenVerzekerdenAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto
     */
    antwoord: VragenDomainAntwoordenVerzekerdenAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenVerzekerdenVolledigAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto
     */
    antwoord: VragenDomainAntwoordenVerzekerdenVolledigAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordVerzekerdenVolledigDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto
 */
export interface VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto extends VragenOfferteVraagAntwoordVraagAntwoordDto {
    /**
     * 
     * @type {VragenDomainAntwoordenWagenparkAntwoord}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto
     */
    antwoord: VragenDomainAntwoordenWagenparkAntwoord;
    /**
     * 
     * @type {VragenOfferteVraagAntwoordPremieVraagAntwoordType}
     * @memberof VragenOfferteVraagAntwoordVraagAntwoordWagenparkDto
     */
    typeName: VragenOfferteVraagAntwoordPremieVraagAntwoordType;
}
/**
 * 
 * @export
 * @interface VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto
 */
export interface VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto {
    /**
     * 
     * @type {string}
     * @memberof VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto
     */
    vraagId: string;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto
     */
    voertuigdataVeld: string;
}
/**
 * 
 * @export
 * @interface VragenProductVragenGetProductVragenFilterDto
 */
export interface VragenProductVragenGetProductVragenFilterDto {
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenFilterDto
     */
    afhankelijkvanProductVraagId: string;
    /**
     * 
     * @type {VragenDomainOperatorEnum}
     * @memberof VragenProductVragenGetProductVragenFilterDto
     */
    operator: VragenDomainOperatorEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof VragenProductVragenGetProductVragenFilterDto
     */
    waarde?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface VragenProductVragenGetProductVragenProductVraagDto
 */
export interface VragenProductVragenGetProductVragenProductVraagDto {
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    vraagId: string;
    /**
     * 
     * @type {number}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    productVraagId: number;
    /**
     * 
     * @type {VragenDomainVraagSoort}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    vraagSoort: VragenDomainVraagSoort;
    /**
     * 
     * @type {VragenDomainFilterSoort}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    filterSoort?: VragenDomainFilterSoort;
    /**
     * 
     * @type {number}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    volgorde?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    tekst: string;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    infotekst?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    verplicht: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    verborgen: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    defaultAntwoord?: string | null;
    /**
     * 
     * @type {VragenDomainProductVraagStatus}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    status: VragenDomainProductVraagStatus;
    /**
     * 
     * @type {VragenDomainVraagType}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    vraagType: VragenDomainVraagType;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    antwoordNietKoppelen?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    antwoordAltijdKoppelen?: boolean | null;
    /**
     * 
     * @type {Array<VragenAntwoordOptiesAntwoordOptieDto>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    mogelijkeAntwoorden: Array<VragenAntwoordOptiesAntwoordOptieDto>;
    /**
     * 
     * @type {Array<VragenProductVragenGetProductVragenFilterDto>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    filters: Array<VragenProductVragenGetProductVragenFilterDto>;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    berekendVeldOperator?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    berekendVeldGekoppeldeProductVraagIds: Array<number>;
    /**
     * 
     * @type {VragenDomainBetreftVraag}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    betreftVraag?: VragenDomainBetreftVraag;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    vraagonderaanSchermZetten?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    meerdereAntwoordenMogelijk: boolean;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    groep?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    kentekenKoppelingAanroepen: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    infofolioKoppelingAanroepen: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    kentekenKoppelingFilterVoertuigSoort?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    maxWaarde?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    minWaarde?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    maxLengte?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    documentTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    bijzonderheden?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    tonenOpOfferte: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    premievaststellingVanToepassing: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    readOnlyBijPremievaststelling: boolean;
    /**
     * 
     * @type {Array<VragenVragenDtosMatrixDimensieDto>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    matrixDimensies: Array<VragenVragenDtosMatrixDimensieDto>;
    /**
     * 
     * @type {Array<VragenVragenDtosVraagDocumentDto>}
     * @memberof VragenProductVragenGetProductVragenProductVraagDto
     */
    vraagDocumenten: Array<VragenVragenDtosVraagDocumentDto>;
}
/**
 * 
 * @export
 * @interface VragenProductVragenProductVraagGroepenProductVraaggroepDto
 */
export interface VragenProductVragenProductVraagGroepenProductVraaggroepDto {
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenProductVraagGroepenProductVraaggroepDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenProductVragenProductVraagGroepenProductVraaggroepDto
     */
    omschrijving: string;
}
/**
 * 
 * @export
 * @interface VragenRisicoscansGetRecenteRisicoscansDto
 */
export interface VragenRisicoscansGetRecenteRisicoscansDto {
    /**
     * 
     * @type {number}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    relatienummer: number;
    /**
     * 
     * @type {string}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    naamRelatie: string;
    /**
     * 
     * @type {string}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    laatstBijgewerkt: string;
    /**
     * 
     * @type {number}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    adviseurnummer: number;
    /**
     * 
     * @type {string}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    naamAdviseur?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VragenRisicoscansGetRecenteRisicoscansDto
     */
    documentUrl?: string | null;
}
/**
 * 
 * @export
 * @interface VragenSbiCodesSbiBeschrijvingDto
 */
export interface VragenSbiCodesSbiBeschrijvingDto {
    /**
     * 
     * @type {string}
     * @memberof VragenSbiCodesSbiBeschrijvingDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenSbiCodesSbiBeschrijvingDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof VragenSbiCodesSbiBeschrijvingDto
     */
    description: string;
}
/**
 * 
 * @export
 * @interface VragenSbiCodesSbiCodeDto
 */
export interface VragenSbiCodesSbiCodeDto {
    /**
     * 
     * @type {string}
     * @memberof VragenSbiCodesSbiCodeDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenSbiCodesSbiCodeDto
     */
    omschrijving: string;
    /**
     * 
     * @type {Array<VragenSbiCodesSbiCodeDto>}
     * @memberof VragenSbiCodesSbiCodeDto
     */
    children?: Array<VragenSbiCodesSbiCodeDto> | null;
}
/**
 * 
 * @export
 * @interface VragenVraagVeldMappingsGetVraagVeldMappingsDto
 */
export interface VragenVraagVeldMappingsGetVraagVeldMappingsDto {
    /**
     * 
     * @type {string}
     * @memberof VragenVraagVeldMappingsGetVraagVeldMappingsDto
     */
    vraagId: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVraagVeldMappingsGetVraagVeldMappingsDto
     */
    veld: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVraagVeldMappingsGetVraagVeldMappingsDto
     */
    productId: string;
    /**
     * 
     * @type {VragenDomainVraagVeldMappingSoort}
     * @memberof VragenVraagVeldMappingsGetVraagVeldMappingsDto
     */
    soortMapping: VragenDomainVraagVeldMappingSoort;
}
/**
 * 
 * @export
 * @interface VragenVragenDtosMatrixDimensieDto
 */
export interface VragenVragenDtosMatrixDimensieDto {
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosMatrixDimensieDto
     */
    vraagId: string;
    /**
     * 
     * @type {VragenDomainMatrixDimensieSoort}
     * @memberof VragenVragenDtosMatrixDimensieDto
     */
    soort: VragenDomainMatrixDimensieSoort;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosMatrixDimensieDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosMatrixDimensieDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof VragenVragenDtosMatrixDimensieDto
     */
    volgorde: number;
}
/**
 * 
 * @export
 * @interface VragenVragenDtosVraagDocumentDto
 */
export interface VragenVragenDtosVraagDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosVraagDocumentDto
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosVraagDocumentDto
     */
    naam: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosVraagDocumentDto
     */
    weergavenaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosVraagDocumentDto
     */
    bestandslocatie: string;
    /**
     * 
     * @type {string}
     * @memberof VragenVragenDtosVraagDocumentDto
     */
    mimeType: string;
}

/**
 * AntwoordenApi - axios parameter creator
 * @export
 */
export const AntwoordenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Maak een nieuwe antwoordenset aan
         * @param {string} [offertenummer] 
         * @param {number} [offerteproductId] 
         * @param {string} [productId] 
         * @param {VragenDomainVraagSoort} [soort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenCreateAntwoordenSetPost: async (offertenummer?: string, offerteproductId?: number, productId?: string, soort?: VragenDomainVraagSoort, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/antwoorden`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offertenummer !== undefined) {
                localVarQueryParameter['offertenummer'] = offertenummer;
            }

            if (offerteproductId !== undefined) {
                localVarQueryParameter['offerteproductId'] = offerteproductId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (soort !== undefined) {
                localVarQueryParameter['soort'] = soort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Maakt één PDF van de opgegeven antwoordensets
         * @param {Array<string>} [antwoordensetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGeneratePdf: async (antwoordensetIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/antwoorden/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (antwoordensetIds) {
                localVarQueryParameter['antwoordensetIds'] = antwoordensetIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haal de beantwoorde vragen op.
         * @param {string} antwoordensetId 
         * @param {string} [productmaatschappijId] 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGet: async (antwoordensetId: string, productmaatschappijId?: string, vraagFilterToepassen?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('antwoordenGet', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/antwoorden/{antwoordensetId}`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productmaatschappijId !== undefined) {
                localVarQueryParameter['productmaatschappijId'] = productmaatschappijId;
            }

            if (vraagFilterToepassen !== undefined) {
                localVarQueryParameter['vraagFilterToepassen'] = vraagFilterToepassen;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt alle antwoordensets van een offerte op.
         * @param {string} offertenummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetAntwoordensets: async (offertenummer: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('antwoordenGetAntwoordensets', 'offertenummer', offertenummer)
            const localVarPath = `/api/v1/antwoorden/offerte/{offertenummer}/antwoordensets`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt de meldcode op voor een bepaald offerteproduct
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetMeldcodeByProduct: async (offertenummer: string, offerteproductId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('antwoordenGetMeldcodeByProduct', 'offertenummer', offertenummer)
            // verify required parameter 'offerteproductId' is not null or undefined
            assertParamExists('antwoordenGetMeldcodeByProduct', 'offerteproductId', offerteproductId)
            const localVarPath = `/api/v1/antwoorden/{offertenummer}/{offerteproductId}/meldcode`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)))
                .replace(`{${"offerteproductId"}}`, encodeURIComponent(String(offerteproductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offertenummer 
         * @param {number} offerteProductId 
         * @param {string} soortVerzekering 
         * @param {string} productmaatschappijId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetOmgekeerdGemapteAntwoorden: async (offertenummer: string, offerteProductId: number, soortVerzekering: string, productmaatschappijId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('antwoordenGetOmgekeerdGemapteAntwoorden', 'offertenummer', offertenummer)
            // verify required parameter 'offerteProductId' is not null or undefined
            assertParamExists('antwoordenGetOmgekeerdGemapteAntwoorden', 'offerteProductId', offerteProductId)
            // verify required parameter 'soortVerzekering' is not null or undefined
            assertParamExists('antwoordenGetOmgekeerdGemapteAntwoorden', 'soortVerzekering', soortVerzekering)
            // verify required parameter 'productmaatschappijId' is not null or undefined
            assertParamExists('antwoordenGetOmgekeerdGemapteAntwoorden', 'productmaatschappijId', productmaatschappijId)
            const localVarPath = `/api/v1/antwoorden/offerte/{offertenummer}/product/{offerteProductId}/productmaatschappij/{productmaatschappijId}/omgekeerdgemapped/soort/{soortVerzekering}`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)))
                .replace(`{${"offerteProductId"}}`, encodeURIComponent(String(offerteProductId)))
                .replace(`{${"soortVerzekering"}}`, encodeURIComponent(String(soortVerzekering)))
                .replace(`{${"productmaatschappijId"}}`, encodeURIComponent(String(productmaatschappijId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haalt de actuele status op van een antwoordenset
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetStatusAntwoordenset: async (antwoordensetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('antwoordenGetStatusAntwoordenset', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/antwoorden/{antwoordensetId}/status`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Offerte.OfferteInzien</li></ul>
         * @summary Haalt de meldcode op basis van het kenteken van een offerteproduct.
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenHaalMeldcodeOpVoorProduct: async (offertenummer: string, offerteproductId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('antwoordenHaalMeldcodeOpVoorProduct', 'offertenummer', offertenummer)
            // verify required parameter 'offerteproductId' is not null or undefined
            assertParamExists('antwoordenHaalMeldcodeOpVoorProduct', 'offerteproductId', offerteproductId)
            const localVarPath = `/api/v1/antwoorden/{offertenummer}/{offerteproductId}/meldcode-ophalen`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)))
                .replace(`{${"offerteproductId"}}`, encodeURIComponent(String(offerteproductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Beantwoord vragen middels een dictionary van vraagId + antwoord en zet deze als draft.
         * @param {string} antwoordensetId 
         * @param {{ [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenPost: async (antwoordensetId: string, requestBody?: { [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('antwoordenPost', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/antwoorden/{antwoordensetId}`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenDefinitiefMaken</li></ul>
         * @summary Maakt de draft premievraag antwoorden definitief
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenPostFinalize: async (antwoordensetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('antwoordenPostFinalize', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/antwoorden/{antwoordensetId}/finalize`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AntwoordenApi - functional programming interface
 * @export
 */
export const AntwoordenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AntwoordenApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Maak een nieuwe antwoordenset aan
         * @param {string} [offertenummer] 
         * @param {number} [offerteproductId] 
         * @param {string} [productId] 
         * @param {VragenDomainVraagSoort} [soort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenCreateAntwoordenSetPost(offertenummer?: string, offerteproductId?: number, productId?: string, soort?: VragenDomainVraagSoort, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenCreateAntwoordenSetPost(offertenummer, offerteproductId, productId, soort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Maakt één PDF van de opgegeven antwoordensets
         * @param {Array<string>} [antwoordensetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGeneratePdf(antwoordensetIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGeneratePdf(antwoordensetIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haal de beantwoorde vragen op.
         * @param {string} antwoordensetId 
         * @param {string} [productmaatschappijId] 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGet(antwoordensetId: string, productmaatschappijId?: string, vraagFilterToepassen?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGet(antwoordensetId, productmaatschappijId, vraagFilterToepassen, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt alle antwoordensets van een offerte op.
         * @param {string} offertenummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGetAntwoordensets(offertenummer: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGetAntwoordensets(offertenummer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt de meldcode op voor een bepaald offerteproduct
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGetMeldcodeByProduct(offertenummer: string, offerteproductId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenOfferteGetMeldcodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGetMeldcodeByProduct(offertenummer, offerteproductId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} offertenummer 
         * @param {number} offerteProductId 
         * @param {string} soortVerzekering 
         * @param {string} productmaatschappijId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer: string, offerteProductId: number, soortVerzekering: string, productmaatschappijId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer, offerteProductId, soortVerzekering, productmaatschappijId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haalt de actuele status op van een antwoordenset
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenGetStatusAntwoordenset(antwoordensetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenOfferteGetAntwoordensetStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenGetStatusAntwoordenset(antwoordensetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Offerte.OfferteInzien</li></ul>
         * @summary Haalt de meldcode op basis van het kenteken van een offerteproduct.
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenHaalMeldcodeOpVoorProduct(offertenummer: string, offerteproductId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenHaalMeldcodeOpVoorProduct(offertenummer, offerteproductId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Beantwoord vragen middels een dictionary van vraagId + antwoord en zet deze als draft.
         * @param {string} antwoordensetId 
         * @param {{ [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenPost(antwoordensetId: string, requestBody?: { [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenPost(antwoordensetId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenDefinitiefMaken</li></ul>
         * @summary Maakt de draft premievraag antwoorden definitief
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async antwoordenPostFinalize(antwoordensetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.antwoordenPostFinalize(antwoordensetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AntwoordenApi - factory interface
 * @export
 */
export const AntwoordenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AntwoordenApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Maak een nieuwe antwoordenset aan
         * @param {string} [offertenummer] 
         * @param {number} [offerteproductId] 
         * @param {string} [productId] 
         * @param {VragenDomainVraagSoort} [soort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenCreateAntwoordenSetPost(offertenummer?: string, offerteproductId?: number, productId?: string, soort?: VragenDomainVraagSoort, options?: any): AxiosPromise<string> {
            return localVarFp.antwoordenCreateAntwoordenSetPost(offertenummer, offerteproductId, productId, soort, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Maakt één PDF van de opgegeven antwoordensets
         * @param {Array<string>} [antwoordensetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGeneratePdf(antwoordensetIds?: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.antwoordenGeneratePdf(antwoordensetIds, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haal de beantwoorde vragen op.
         * @param {string} antwoordensetId 
         * @param {string} [productmaatschappijId] 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGet(antwoordensetId: string, productmaatschappijId?: string, vraagFilterToepassen?: boolean, options?: any): AxiosPromise<Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto> {
            return localVarFp.antwoordenGet(antwoordensetId, productmaatschappijId, vraagFilterToepassen, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt alle antwoordensets van een offerte op.
         * @param {string} offertenummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetAntwoordensets(offertenummer: string, options?: any): AxiosPromise<CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto> {
            return localVarFp.antwoordenGetAntwoordensets(offertenummer, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Haalt de meldcode op voor een bepaald offerteproduct
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetMeldcodeByProduct(offertenummer: string, offerteproductId: number, options?: any): AxiosPromise<Result1OfVragenOfferteGetMeldcodeResponse> {
            return localVarFp.antwoordenGetMeldcodeByProduct(offertenummer, offerteproductId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} offertenummer 
         * @param {number} offerteProductId 
         * @param {string} soortVerzekering 
         * @param {string} productmaatschappijId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer: string, offerteProductId: number, soortVerzekering: string, productmaatschappijId: string, options?: any): AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString> {
            return localVarFp.antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer, offerteProductId, soortVerzekering, productmaatschappijId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haalt de actuele status op van een antwoordenset
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenGetStatusAntwoordenset(antwoordensetId: string, options?: any): AxiosPromise<Result1OfVragenOfferteGetAntwoordensetStatusDto> {
            return localVarFp.antwoordenGetStatusAntwoordenset(antwoordensetId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Offerte.OfferteInzien</li></ul>
         * @summary Haalt de meldcode op basis van het kenteken van een offerteproduct.
         * @param {string} offertenummer 
         * @param {number} offerteproductId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenHaalMeldcodeOpVoorProduct(offertenummer: string, offerteproductId: number, options?: any): AxiosPromise<Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse> {
            return localVarFp.antwoordenHaalMeldcodeOpVoorProduct(offertenummer, offerteproductId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
         * @summary Beantwoord vragen middels een dictionary van vraagId + antwoord en zet deze als draft.
         * @param {string} antwoordensetId 
         * @param {{ [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenPost(antwoordensetId: string, requestBody?: { [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }, options?: any): AxiosPromise<void> {
            return localVarFp.antwoordenPost(antwoordensetId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenDefinitiefMaken</li></ul>
         * @summary Maakt de draft premievraag antwoorden definitief
         * @param {string} antwoordensetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        antwoordenPostFinalize(antwoordensetId: string, options?: any): AxiosPromise<void> {
            return localVarFp.antwoordenPostFinalize(antwoordensetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AntwoordenApi - interface
 * @export
 * @interface AntwoordenApi
 */
export interface AntwoordenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
     * @summary Maak een nieuwe antwoordenset aan
     * @param {string} [offertenummer] 
     * @param {number} [offerteproductId] 
     * @param {string} [productId] 
     * @param {VragenDomainVraagSoort} [soort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenCreateAntwoordenSetPost(offertenummer?: string, offerteproductId?: number, productId?: string, soort?: VragenDomainVraagSoort, options?: any): AxiosPromise<string>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Maakt één PDF van de opgegeven antwoordensets
     * @param {Array<string>} [antwoordensetIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGeneratePdf(antwoordensetIds?: Array<string>, options?: any): AxiosPromise<any>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haal de beantwoorde vragen op.
     * @param {string} antwoordensetId 
     * @param {string} [productmaatschappijId] 
     * @param {boolean} [vraagFilterToepassen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGet(antwoordensetId: string, productmaatschappijId?: string, vraagFilterToepassen?: boolean, options?: any): AxiosPromise<Result1OfVragenOfferteVraagAntwoordAntwoordenSetDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haalt alle antwoordensets van een offerte op.
     * @param {string} offertenummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGetAntwoordensets(offertenummer: string, options?: any): AxiosPromise<CollectionResultOfVragenOfferteAntwoordenSetsGetAntwoordensetsDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haalt de meldcode op voor een bepaald offerteproduct
     * @param {string} offertenummer 
     * @param {number} offerteproductId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGetMeldcodeByProduct(offertenummer: string, offerteproductId: number, options?: any): AxiosPromise<Result1OfVragenOfferteGetMeldcodeResponse>;

    /**
     * 
     * @param {string} offertenummer 
     * @param {number} offerteProductId 
     * @param {string} soortVerzekering 
     * @param {string} productmaatschappijId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer: string, offerteProductId: number, soortVerzekering: string, productmaatschappijId: string, options?: any): AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSystemStringAndSystemString>;

    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haalt de actuele status op van een antwoordenset
     * @param {string} antwoordensetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenGetStatusAntwoordenset(antwoordensetId: string, options?: any): AxiosPromise<Result1OfVragenOfferteGetAntwoordensetStatusDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Offerte.OfferteInzien</li></ul>
     * @summary Haalt de meldcode op basis van het kenteken van een offerteproduct.
     * @param {string} offertenummer 
     * @param {number} offerteproductId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenHaalMeldcodeOpVoorProduct(offertenummer: string, offerteproductId: number, options?: any): AxiosPromise<Result1OfVragenOfferteHaalMeldcodeOpVoorOfferteproductResponse>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
     * @summary Beantwoord vragen middels een dictionary van vraagId + antwoord en zet deze als draft.
     * @param {string} antwoordensetId 
     * @param {{ [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenPost(antwoordensetId: string, requestBody?: { [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }, options?: any): AxiosPromise<void>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenDefinitiefMaken</li></ul>
     * @summary Maakt de draft premievraag antwoorden definitief
     * @param {string} antwoordensetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApiInterface
     */
    antwoordenPostFinalize(antwoordensetId: string, options?: any): AxiosPromise<void>;

}

/**
 * AntwoordenApi - object-oriented interface
 * @export
 * @class AntwoordenApi
 * @extends {BaseAPI}
 */
export class AntwoordenApi extends BaseAPI implements AntwoordenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
     * @summary Maak een nieuwe antwoordenset aan
     * @param {string} [offertenummer] 
     * @param {number} [offerteproductId] 
     * @param {string} [productId] 
     * @param {VragenDomainVraagSoort} [soort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenCreateAntwoordenSetPost(offertenummer?: string, offerteproductId?: number, productId?: string, soort?: VragenDomainVraagSoort, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenCreateAntwoordenSetPost(offertenummer, offerteproductId, productId, soort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Maakt één PDF van de opgegeven antwoordensets
     * @param {Array<string>} [antwoordensetIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGeneratePdf(antwoordensetIds?: Array<string>, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGeneratePdf(antwoordensetIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haal de beantwoorde vragen op.
     * @param {string} antwoordensetId 
     * @param {string} [productmaatschappijId] 
     * @param {boolean} [vraagFilterToepassen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGet(antwoordensetId: string, productmaatschappijId?: string, vraagFilterToepassen?: boolean, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGet(antwoordensetId, productmaatschappijId, vraagFilterToepassen, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haalt alle antwoordensets van een offerte op.
     * @param {string} offertenummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGetAntwoordensets(offertenummer: string, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGetAntwoordensets(offertenummer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Haalt de meldcode op voor een bepaald offerteproduct
     * @param {string} offertenummer 
     * @param {number} offerteproductId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGetMeldcodeByProduct(offertenummer: string, offerteproductId: number, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGetMeldcodeByProduct(offertenummer, offerteproductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} offertenummer 
     * @param {number} offerteProductId 
     * @param {string} soortVerzekering 
     * @param {string} productmaatschappijId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer: string, offerteProductId: number, soortVerzekering: string, productmaatschappijId: string, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGetOmgekeerdGemapteAntwoorden(offertenummer, offerteProductId, soortVerzekering, productmaatschappijId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haalt de actuele status op van een antwoordenset
     * @param {string} antwoordensetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenGetStatusAntwoordenset(antwoordensetId: string, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenGetStatusAntwoordenset(antwoordensetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Offerte.OfferteInzien</li></ul>
     * @summary Haalt de meldcode op basis van het kenteken van een offerteproduct.
     * @param {string} offertenummer 
     * @param {number} offerteproductId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenHaalMeldcodeOpVoorProduct(offertenummer: string, offerteproductId: number, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenHaalMeldcodeOpVoorProduct(offertenummer, offerteproductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenGeven</li></ul>
     * @summary Beantwoord vragen middels een dictionary van vraagId + antwoord en zet deze als draft.
     * @param {string} antwoordensetId 
     * @param {{ [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenPost(antwoordensetId: string, requestBody?: { [key: string]: VragenDomainAntwoordenStringAntwoord | VragenDomainAntwoordenMultipleStringAntwoord | VragenDomainAntwoordenNummerAntwoord | VragenDomainAntwoordenDecimaalAntwoord | VragenDomainAntwoordenAdresAntwoord | VragenDomainAntwoordenGerelateerdeAdressenAntwoord | VragenDomainAntwoordenSchadeverledenAntwoord | VragenDomainAntwoordenVerzekerdenAntwoord | VragenDomainAntwoordenVerzekerdenVolledigAntwoord | VragenDomainAntwoordenMatrixAntwoord | VragenDomainAntwoordenNullAntwoord | VragenDomainAntwoordenWagenparkAntwoord; }, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenPost(antwoordensetId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenDefinitiefMaken</li></ul>
     * @summary Maakt de draft premievraag antwoorden definitief
     * @param {string} antwoordensetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntwoordenApi
     */
    public antwoordenPostFinalize(antwoordensetId: string, options?: any) {
        return AntwoordenApiFp(this.configuration).antwoordenPostFinalize(antwoordensetId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ControleregelsApi - axios parameter creator
 * @export
 */
export const ControleregelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de acceptatievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorAcceptatievragen: async (offertenummer: string, offerteproductId?: number, debug?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('controleregelsCheckControleregelsVoorAcceptatievragen', 'offertenummer', offertenummer)
            const localVarPath = `/api/v1/acceptatieregels/{offertenummer}/acceptatievragen`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerteproductId !== undefined) {
                localVarQueryParameter['offerteproductId'] = offerteproductId;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de controleregels met gradatie NietTonenInVergelijking uit voor een productmaatschappij
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {string} [productmaatschappijId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorPremieoverzicht: async (offertenummer: string, offerteproductId?: number, productmaatschappijId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('controleregelsCheckControleregelsVoorPremieoverzicht', 'offertenummer', offertenummer)
            const localVarPath = `/api/v1/acceptatieregels/{offertenummer}/niet-tonen-in-vergelijking`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerteproductId !== undefined) {
                localVarQueryParameter['offerteproductId'] = offerteproductId;
            }

            if (productmaatschappijId !== undefined) {
                localVarQueryParameter['productmaatschappijId'] = productmaatschappijId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de premievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorPremievragen: async (offertenummer: string, offerteproductId?: number, debug?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('controleregelsCheckControleregelsVoorPremievragen', 'offertenummer', offertenummer)
            const localVarPath = `/api/v1/acceptatieregels/{offertenummer}/premievragen`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerteproductId !== undefined) {
                localVarQueryParameter['offerteproductId'] = offerteproductId;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControleregelsApi - functional programming interface
 * @export
 */
export const ControleregelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControleregelsApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de acceptatievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer, offerteproductId, debug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de controleregels met gradatie NietTonenInVergelijking uit voor een productmaatschappij
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {string} [productmaatschappijId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer: string, offerteproductId?: number, productmaatschappijId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer, offerteproductId, productmaatschappijId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de premievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controleregelsCheckControleregelsVoorPremievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controleregelsCheckControleregelsVoorPremievragen(offertenummer, offerteproductId, debug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ControleregelsApi - factory interface
 * @export
 */
export const ControleregelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControleregelsApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de acceptatievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto> {
            return localVarFp.controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer, offerteproductId, debug, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de controleregels met gradatie NietTonenInVergelijking uit voor een productmaatschappij
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {string} [productmaatschappijId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer: string, offerteproductId?: number, productmaatschappijId?: string, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto> {
            return localVarFp.controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer, offerteproductId, productmaatschappijId, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert de acceptatiecontroles uit over de premievragen met gradatie NietMogelijk
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controleregelsCheckControleregelsVoorPremievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto> {
            return localVarFp.controleregelsCheckControleregelsVoorPremievragen(offertenummer, offerteproductId, debug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ControleregelsApi - interface
 * @export
 * @interface ControleregelsApi
 */
export interface ControleregelsApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de acceptatiecontroles uit over de acceptatievragen met gradatie NietMogelijk
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApiInterface
     */
    controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de controleregels met gradatie NietTonenInVergelijking uit voor een productmaatschappij
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {string} [productmaatschappijId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApiInterface
     */
    controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer: string, offerteproductId?: number, productmaatschappijId?: string, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de acceptatiecontroles uit over de premievragen met gradatie NietMogelijk
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApiInterface
     */
    controleregelsCheckControleregelsVoorPremievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any): AxiosPromise<Result1OfVragenControleregelsVoerControleregelsUitDto>;

}

/**
 * ControleregelsApi - object-oriented interface
 * @export
 * @class ControleregelsApi
 * @extends {BaseAPI}
 */
export class ControleregelsApi extends BaseAPI implements ControleregelsApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de acceptatiecontroles uit over de acceptatievragen met gradatie NietMogelijk
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApi
     */
    public controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any) {
        return ControleregelsApiFp(this.configuration).controleregelsCheckControleregelsVoorAcceptatievragen(offertenummer, offerteproductId, debug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de controleregels met gradatie NietTonenInVergelijking uit voor een productmaatschappij
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {string} [productmaatschappijId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApi
     */
    public controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer: string, offerteproductId?: number, productmaatschappijId?: string, options?: any) {
        return ControleregelsApiFp(this.configuration).controleregelsCheckControleregelsVoorPremieoverzicht(offertenummer, offerteproductId, productmaatschappijId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert de acceptatiecontroles uit over de premievragen met gradatie NietMogelijk
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControleregelsApi
     */
    public controleregelsCheckControleregelsVoorPremievragen(offertenummer: string, offerteproductId?: number, debug?: boolean, options?: any) {
        return ControleregelsApiFp(this.configuration).controleregelsCheckControleregelsVoorPremievragen(offertenummer, offerteproductId, debug, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HoedanighedenApi - axios parameter creator
 * @export
 */
export const HoedanighedenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert hoedanigheid controles uit voor een offerteproduct
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenControleerHoedanigheden: async (offertenummer: string, offerteproductId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'offertenummer' is not null or undefined
            assertParamExists('hoedanighedenControleerHoedanigheden', 'offertenummer', offertenummer)
            const localVarPath = `/api/v1/hoedanigheden/{offertenummer}/controleren`
                .replace(`{${"offertenummer"}}`, encodeURIComponent(String(offertenummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offerteproductId !== undefined) {
                localVarQueryParameter['offerteproductId'] = offerteproductId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Geeft de SUREbusiness hoedanigheden terug die horen bij de opgegeven SBI-code.
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenGet: async (sbiCode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/hoedanigheden`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sbiCode !== undefined) {
                localVarQueryParameter['sbiCode'] = sbiCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} surecode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenGetSbiObvHoedanigheid: async (surecode: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'surecode' is not null or undefined
            assertParamExists('hoedanighedenGetSbiObvHoedanigheid', 'surecode', surecode)
            const localVarPath = `/api/v1/hoedanigheden/{surecode}/sbi-codes`
                .replace(`{${"surecode"}}`, encodeURIComponent(String(surecode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HoedanighedenApi - functional programming interface
 * @export
 */
export const HoedanighedenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HoedanighedenApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert hoedanigheid controles uit voor een offerteproduct
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hoedanighedenControleerHoedanigheden(offertenummer: string, offerteproductId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hoedanighedenControleerHoedanigheden(offertenummer, offerteproductId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Geeft de SUREbusiness hoedanigheden terug die horen bij de opgegeven SBI-code.
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hoedanighedenGet(sbiCode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hoedanighedenGet(sbiCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} surecode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hoedanighedenGetSbiObvHoedanigheid(surecode: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenDomainHoedanighedenSbi2025Code>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hoedanighedenGetSbiObvHoedanigheid(surecode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HoedanighedenApi - factory interface
 * @export
 */
export const HoedanighedenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HoedanighedenApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
         * @summary Voert hoedanigheid controles uit voor een offerteproduct
         * @param {string} offertenummer 
         * @param {number} [offerteproductId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenControleerHoedanigheden(offertenummer: string, offerteproductId?: number, options?: any): AxiosPromise<Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto> {
            return localVarFp.hoedanighedenControleerHoedanigheden(offertenummer, offerteproductId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Geeft de SUREbusiness hoedanigheden terug die horen bij de opgegeven SBI-code.
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenGet(sbiCode?: string, options?: any): AxiosPromise<CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto> {
            return localVarFp.hoedanighedenGet(sbiCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} surecode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoedanighedenGetSbiObvHoedanigheid(surecode: string, options?: any): AxiosPromise<CollectionResultOfVragenDomainHoedanighedenSbi2025Code> {
            return localVarFp.hoedanighedenGetSbiObvHoedanigheid(surecode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HoedanighedenApi - interface
 * @export
 * @interface HoedanighedenApi
 */
export interface HoedanighedenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert hoedanigheid controles uit voor een offerteproduct
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApiInterface
     */
    hoedanighedenControleerHoedanigheden(offertenummer: string, offerteproductId?: number, options?: any): AxiosPromise<Result1OfVragenHoedanighedenControlerenVoerHoedanigheidControlesUitDto>;

    /**
     * 
     * @summary Geeft de SUREbusiness hoedanigheden terug die horen bij de opgegeven SBI-code.
     * @param {string} [sbiCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApiInterface
     */
    hoedanighedenGet(sbiCode?: string, options?: any): AxiosPromise<CollectionResultOfVragenHoedanighedenGetHoedanighedenHoedanigheidDto>;

    /**
     * 
     * @param {string} surecode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApiInterface
     */
    hoedanighedenGetSbiObvHoedanigheid(surecode: string, options?: any): AxiosPromise<CollectionResultOfVragenDomainHoedanighedenSbi2025Code>;

}

/**
 * HoedanighedenApi - object-oriented interface
 * @export
 * @class HoedanighedenApi
 * @extends {BaseAPI}
 */
export class HoedanighedenApi extends BaseAPI implements HoedanighedenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.AntwoordenInzien</li></ul>
     * @summary Voert hoedanigheid controles uit voor een offerteproduct
     * @param {string} offertenummer 
     * @param {number} [offerteproductId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApi
     */
    public hoedanighedenControleerHoedanigheden(offertenummer: string, offerteproductId?: number, options?: any) {
        return HoedanighedenApiFp(this.configuration).hoedanighedenControleerHoedanigheden(offertenummer, offerteproductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Geeft de SUREbusiness hoedanigheden terug die horen bij de opgegeven SBI-code.
     * @param {string} [sbiCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApi
     */
    public hoedanighedenGet(sbiCode?: string, options?: any) {
        return HoedanighedenApiFp(this.configuration).hoedanighedenGet(sbiCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} surecode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoedanighedenApi
     */
    public hoedanighedenGetSbiObvHoedanigheid(surecode: string, options?: any) {
        return HoedanighedenApiFp(this.configuration).hoedanighedenGetSbiObvHoedanigheid(surecode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MappingVoertuigdataApi - axios parameter creator
 * @export
 */
export const MappingVoertuigdataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Geeft een mapping lijst van voertuigdata naar vraag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingVoertuigdataVoertuigdata: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/mapping/voertuigdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MappingVoertuigdataApi - functional programming interface
 * @export
 */
export const MappingVoertuigdataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MappingVoertuigdataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Geeft een mapping lijst van voertuigdata naar vraag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mappingVoertuigdataVoertuigdata(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mappingVoertuigdataVoertuigdata(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MappingVoertuigdataApi - factory interface
 * @export
 */
export const MappingVoertuigdataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MappingVoertuigdataApiFp(configuration)
    return {
        /**
         * 
         * @summary Geeft een mapping lijst van voertuigdata naar vraag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mappingVoertuigdataVoertuigdata(options?: any): AxiosPromise<CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto> {
            return localVarFp.mappingVoertuigdataVoertuigdata(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MappingVoertuigdataApi - interface
 * @export
 * @interface MappingVoertuigdataApi
 */
export interface MappingVoertuigdataApiInterface {
    /**
     * 
     * @summary Geeft een mapping lijst van voertuigdata naar vraag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MappingVoertuigdataApiInterface
     */
    mappingVoertuigdataVoertuigdata(options?: any): AxiosPromise<CollectionResultOfVragenProductVraagMappingsGetVoertuigdataNaarVraagMappingVoertuigdataNaarVraagMappingDto>;

}

/**
 * MappingVoertuigdataApi - object-oriented interface
 * @export
 * @class MappingVoertuigdataApi
 * @extends {BaseAPI}
 */
export class MappingVoertuigdataApi extends BaseAPI implements MappingVoertuigdataApiInterface {
    /**
     * 
     * @summary Geeft een mapping lijst van voertuigdata naar vraag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MappingVoertuigdataApi
     */
    public mappingVoertuigdataVoertuigdata(options?: any) {
        return MappingVoertuigdataApiFp(this.configuration).mappingVoertuigdataVoertuigdata(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductVragenApi - axios parameter creator
 * @export
 */
export const ProductVragenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft productvragen terug die horen bij een bepaald product en soort vraag.
         * @param {string} productId 
         * @param {VragenDomainVraagSoort} [vraagSoort] 
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVragenGetByProductId: async (productId: string, vraagSoort?: VragenDomainVraagSoort, sbiCode?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productVragenGetByProductId', 'productId', productId)
            const localVarPath = `/api/v1/producten/{productId}/productvragen`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vraagSoort !== undefined) {
                localVarQueryParameter['vraagSoort'] = vraagSoort;
            }

            if (sbiCode !== undefined) {
                localVarQueryParameter['sbiCode'] = sbiCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de vraaggroepen terug.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVragenGetProductVraaggroepen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/producten/vraaggroepen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductVragenApi - functional programming interface
 * @export
 */
export const ProductVragenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductVragenApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft productvragen terug die horen bij een bepaald product en soort vraag.
         * @param {string} productId 
         * @param {VragenDomainVraagSoort} [vraagSoort] 
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVragenGetByProductId(productId: string, vraagSoort?: VragenDomainVraagSoort, sbiCode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVragenGetByProductId(productId, vraagSoort, sbiCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de vraaggroepen terug.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVragenGetProductVraaggroepen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVragenGetProductVraaggroepen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductVragenApi - factory interface
 * @export
 */
export const ProductVragenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductVragenApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft productvragen terug die horen bij een bepaald product en soort vraag.
         * @param {string} productId 
         * @param {VragenDomainVraagSoort} [vraagSoort] 
         * @param {string} [sbiCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVragenGetByProductId(productId: string, vraagSoort?: VragenDomainVraagSoort, sbiCode?: string, options?: any): AxiosPromise<CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto> {
            return localVarFp.productVragenGetByProductId(productId, vraagSoort, sbiCode, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de vraaggroepen terug.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVragenGetProductVraaggroepen(options?: any): AxiosPromise<CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto> {
            return localVarFp.productVragenGetProductVraaggroepen(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductVragenApi - interface
 * @export
 * @interface ProductVragenApi
 */
export interface ProductVragenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft productvragen terug die horen bij een bepaald product en soort vraag.
     * @param {string} productId 
     * @param {VragenDomainVraagSoort} [vraagSoort] 
     * @param {string} [sbiCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVragenApiInterface
     */
    productVragenGetByProductId(productId: string, vraagSoort?: VragenDomainVraagSoort, sbiCode?: string, options?: any): AxiosPromise<CollectionResultOfVragenProductVragenGetProductVragenProductVraagDto>;

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft de vraaggroepen terug.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVragenApiInterface
     */
    productVragenGetProductVraaggroepen(options?: any): AxiosPromise<CollectionResultOfVragenProductVragenProductVraagGroepenProductVraaggroepDto>;

}

/**
 * ProductVragenApi - object-oriented interface
 * @export
 * @class ProductVragenApi
 * @extends {BaseAPI}
 */
export class ProductVragenApi extends BaseAPI implements ProductVragenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft productvragen terug die horen bij een bepaald product en soort vraag.
     * @param {string} productId 
     * @param {VragenDomainVraagSoort} [vraagSoort] 
     * @param {string} [sbiCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVragenApi
     */
    public productVragenGetByProductId(productId: string, vraagSoort?: VragenDomainVraagSoort, sbiCode?: string, options?: any) {
        return ProductVragenApiFp(this.configuration).productVragenGetByProductId(productId, vraagSoort, sbiCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft de vraaggroepen terug.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductVragenApi
     */
    public productVragenGetProductVraaggroepen(options?: any) {
        return ProductVragenApiFp(this.configuration).productVragenGetProductVraaggroepen(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RisicoscansApi - axios parameter creator
 * @export
 */
export const RisicoscansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Risicoscan.Inzien</li></ul>
         * @summary Haalt de recente risicoscans voor de overzichtspagina op.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        risicoscansGet: async (limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/risicoscans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RisicoscansApi - functional programming interface
 * @export
 */
export const RisicoscansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RisicoscansApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Risicoscan.Inzien</li></ul>
         * @summary Haalt de recente risicoscans voor de overzichtspagina op.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async risicoscansGet(limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.risicoscansGet(limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RisicoscansApi - factory interface
 * @export
 */
export const RisicoscansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RisicoscansApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Risicoscan.Inzien</li></ul>
         * @summary Haalt de recente risicoscans voor de overzichtspagina op.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        risicoscansGet(limit?: number, options?: any): AxiosPromise<CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto> {
            return localVarFp.risicoscansGet(limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RisicoscansApi - interface
 * @export
 * @interface RisicoscansApi
 */
export interface RisicoscansApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Risicoscan.Inzien</li></ul>
     * @summary Haalt de recente risicoscans voor de overzichtspagina op.
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RisicoscansApiInterface
     */
    risicoscansGet(limit?: number, options?: any): AxiosPromise<CollectionResultOfVragenRisicoscansGetRecenteRisicoscansDto>;

}

/**
 * RisicoscansApi - object-oriented interface
 * @export
 * @class RisicoscansApi
 * @extends {BaseAPI}
 */
export class RisicoscansApi extends BaseAPI implements RisicoscansApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Risicoscan.Inzien</li></ul>
     * @summary Haalt de recente risicoscans voor de overzichtspagina op.
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RisicoscansApi
     */
    public risicoscansGet(limit?: number, options?: any) {
        return RisicoscansApiFp(this.configuration).risicoscansGet(limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SbiCodesApi - axios parameter creator
 * @export
 */
export const SbiCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbiCodesGetSbiCodes: async (search?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sbicodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sbiCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbiCodesSbiBeschrijving: async (sbiCode: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sbiCode' is not null or undefined
            assertParamExists('sbiCodesSbiBeschrijving', 'sbiCode', sbiCode)
            const localVarPath = `/api/v1/sbicodes/{sbiCode}`
                .replace(`{${"sbiCode"}}`, encodeURIComponent(String(sbiCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SbiCodesApi - functional programming interface
 * @export
 */
export const SbiCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SbiCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sbiCodesGetSbiCodes(search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenSbiCodesSbiCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sbiCodesGetSbiCodes(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sbiCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sbiCodesSbiBeschrijving(sbiCode: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfVragenSbiCodesSbiBeschrijvingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sbiCodesSbiBeschrijving(sbiCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SbiCodesApi - factory interface
 * @export
 */
export const SbiCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SbiCodesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbiCodesGetSbiCodes(search?: string, options?: any): AxiosPromise<CollectionResultOfVragenSbiCodesSbiCodeDto> {
            return localVarFp.sbiCodesGetSbiCodes(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sbiCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sbiCodesSbiBeschrijving(sbiCode: string, options?: any): AxiosPromise<Result1OfVragenSbiCodesSbiBeschrijvingDto> {
            return localVarFp.sbiCodesSbiBeschrijving(sbiCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SbiCodesApi - interface
 * @export
 * @interface SbiCodesApi
 */
export interface SbiCodesApiInterface {
    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SbiCodesApiInterface
     */
    sbiCodesGetSbiCodes(search?: string, options?: any): AxiosPromise<CollectionResultOfVragenSbiCodesSbiCodeDto>;

    /**
     * 
     * @param {string} sbiCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SbiCodesApiInterface
     */
    sbiCodesSbiBeschrijving(sbiCode: string, options?: any): AxiosPromise<Result1OfVragenSbiCodesSbiBeschrijvingDto>;

}

/**
 * SbiCodesApi - object-oriented interface
 * @export
 * @class SbiCodesApi
 * @extends {BaseAPI}
 */
export class SbiCodesApi extends BaseAPI implements SbiCodesApiInterface {
    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SbiCodesApi
     */
    public sbiCodesGetSbiCodes(search?: string, options?: any) {
        return SbiCodesApiFp(this.configuration).sbiCodesGetSbiCodes(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sbiCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SbiCodesApi
     */
    public sbiCodesSbiBeschrijving(sbiCode: string, options?: any) {
        return SbiCodesApiFp(this.configuration).sbiCodesSbiBeschrijving(sbiCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VraagAntwoordApi - axios parameter creator
 * @export
 */
export const VraagAntwoordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {boolean} [vraagInResultaatWanneerFilterBronVraagNietBeantwoord] 
         * @param {boolean} [tonenOpOfferteToepassen] 
         * @param {boolean} [verborgenVragenTeruggeven] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagAntwoordGet: async (antwoordensetId: string, vraagFilterToepassen?: boolean, vraagInResultaatWanneerFilterBronVraagNietBeantwoord?: boolean, tonenOpOfferteToepassen?: boolean, verborgenVragenTeruggeven?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('vraagAntwoordGet', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/vraagantwoord/{antwoordensetId}`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vraagFilterToepassen !== undefined) {
                localVarQueryParameter['vraagFilterToepassen'] = vraagFilterToepassen;
            }

            if (vraagInResultaatWanneerFilterBronVraagNietBeantwoord !== undefined) {
                localVarQueryParameter['vraagInResultaatWanneerFilterBronVraagNietBeantwoord'] = vraagInResultaatWanneerFilterBronVraagNietBeantwoord;
            }

            if (tonenOpOfferteToepassen !== undefined) {
                localVarQueryParameter['tonenOpOfferteToepassen'] = tonenOpOfferteToepassen;
            }

            if (verborgenVragenTeruggeven !== undefined) {
                localVarQueryParameter['verborgenVragenTeruggeven'] = verborgenVragenTeruggeven;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {Array<VragenDomainBetreftVraag>} [inclusiefVerborgenVragenMetBetreftVraag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagAntwoordGetSimpleFormatted: async (antwoordensetId: string, inclusiefVerborgenVragenMetBetreftVraag?: Array<VragenDomainBetreftVraag>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'antwoordensetId' is not null or undefined
            assertParamExists('vraagAntwoordGetSimpleFormatted', 'antwoordensetId', antwoordensetId)
            const localVarPath = `/api/v1/vraagantwoord/simpel/{antwoordensetId}`
                .replace(`{${"antwoordensetId"}}`, encodeURIComponent(String(antwoordensetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inclusiefVerborgenVragenMetBetreftVraag) {
                localVarQueryParameter['inclusiefVerborgenVragenMetBetreftVraag'] = inclusiefVerborgenVragenMetBetreftVraag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VraagAntwoordApi - functional programming interface
 * @export
 */
export const VraagAntwoordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VraagAntwoordApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {boolean} [vraagInResultaatWanneerFilterBronVraagNietBeantwoord] 
         * @param {boolean} [tonenOpOfferteToepassen] 
         * @param {boolean} [verborgenVragenTeruggeven] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vraagAntwoordGet(antwoordensetId: string, vraagFilterToepassen?: boolean, vraagInResultaatWanneerFilterBronVraagNietBeantwoord?: boolean, tonenOpOfferteToepassen?: boolean, verborgenVragenTeruggeven?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vraagAntwoordGet(antwoordensetId, vraagFilterToepassen, vraagInResultaatWanneerFilterBronVraagNietBeantwoord, tonenOpOfferteToepassen, verborgenVragenTeruggeven, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {Array<VragenDomainBetreftVraag>} [inclusiefVerborgenVragenMetBetreftVraag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vraagAntwoordGetSimpleFormatted(antwoordensetId: string, inclusiefVerborgenVragenMetBetreftVraag?: Array<VragenDomainBetreftVraag>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vraagAntwoordGetSimpleFormatted(antwoordensetId, inclusiefVerborgenVragenMetBetreftVraag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VraagAntwoordApi - factory interface
 * @export
 */
export const VraagAntwoordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VraagAntwoordApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {boolean} [vraagFilterToepassen] 
         * @param {boolean} [vraagInResultaatWanneerFilterBronVraagNietBeantwoord] 
         * @param {boolean} [tonenOpOfferteToepassen] 
         * @param {boolean} [verborgenVragenTeruggeven] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagAntwoordGet(antwoordensetId: string, vraagFilterToepassen?: boolean, vraagInResultaatWanneerFilterBronVraagNietBeantwoord?: boolean, tonenOpOfferteToepassen?: boolean, verborgenVragenTeruggeven?: boolean, options?: any): AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto> {
            return localVarFp.vraagAntwoordGet(antwoordensetId, vraagFilterToepassen, vraagInResultaatWanneerFilterBronVraagNietBeantwoord, tonenOpOfferteToepassen, verborgenVragenTeruggeven, options).then((request) => request(axios, basePath));
        },
        /**
         *  <br /> Required permissions:<br /> <ul></ul>
         * @summary Haal vragen met antwoorden op en pas vraag filters toe.
         * @param {string} antwoordensetId 
         * @param {Array<VragenDomainBetreftVraag>} [inclusiefVerborgenVragenMetBetreftVraag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagAntwoordGetSimpleFormatted(antwoordensetId: string, inclusiefVerborgenVragenMetBetreftVraag?: Array<VragenDomainBetreftVraag>, options?: any): AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto> {
            return localVarFp.vraagAntwoordGetSimpleFormatted(antwoordensetId, inclusiefVerborgenVragenMetBetreftVraag, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VraagAntwoordApi - interface
 * @export
 * @interface VraagAntwoordApi
 */
export interface VraagAntwoordApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haal vragen met antwoorden op en pas vraag filters toe.
     * @param {string} antwoordensetId 
     * @param {boolean} [vraagFilterToepassen] 
     * @param {boolean} [vraagInResultaatWanneerFilterBronVraagNietBeantwoord] 
     * @param {boolean} [tonenOpOfferteToepassen] 
     * @param {boolean} [verborgenVragenTeruggeven] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagAntwoordApiInterface
     */
    vraagAntwoordGet(antwoordensetId: string, vraagFilterToepassen?: boolean, vraagInResultaatWanneerFilterBronVraagNietBeantwoord?: boolean, tonenOpOfferteToepassen?: boolean, verborgenVragenTeruggeven?: boolean, options?: any): AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordDto>;

    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haal vragen met antwoorden op en pas vraag filters toe.
     * @param {string} antwoordensetId 
     * @param {Array<VragenDomainBetreftVraag>} [inclusiefVerborgenVragenMetBetreftVraag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagAntwoordApiInterface
     */
    vraagAntwoordGetSimpleFormatted(antwoordensetId: string, inclusiefVerborgenVragenMetBetreftVraag?: Array<VragenDomainBetreftVraag>, options?: any): AxiosPromise<CollectionResultOfVragenOfferteVraagAntwoordGetVragenMetAntwoordVraagEnAntwoordSimpleDto>;

}

/**
 * VraagAntwoordApi - object-oriented interface
 * @export
 * @class VraagAntwoordApi
 * @extends {BaseAPI}
 */
export class VraagAntwoordApi extends BaseAPI implements VraagAntwoordApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haal vragen met antwoorden op en pas vraag filters toe.
     * @param {string} antwoordensetId 
     * @param {boolean} [vraagFilterToepassen] 
     * @param {boolean} [vraagInResultaatWanneerFilterBronVraagNietBeantwoord] 
     * @param {boolean} [tonenOpOfferteToepassen] 
     * @param {boolean} [verborgenVragenTeruggeven] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagAntwoordApi
     */
    public vraagAntwoordGet(antwoordensetId: string, vraagFilterToepassen?: boolean, vraagInResultaatWanneerFilterBronVraagNietBeantwoord?: boolean, tonenOpOfferteToepassen?: boolean, verborgenVragenTeruggeven?: boolean, options?: any) {
        return VraagAntwoordApiFp(this.configuration).vraagAntwoordGet(antwoordensetId, vraagFilterToepassen, vraagInResultaatWanneerFilterBronVraagNietBeantwoord, tonenOpOfferteToepassen, verborgenVragenTeruggeven, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  <br /> Required permissions:<br /> <ul></ul>
     * @summary Haal vragen met antwoorden op en pas vraag filters toe.
     * @param {string} antwoordensetId 
     * @param {Array<VragenDomainBetreftVraag>} [inclusiefVerborgenVragenMetBetreftVraag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagAntwoordApi
     */
    public vraagAntwoordGetSimpleFormatted(antwoordensetId: string, inclusiefVerborgenVragenMetBetreftVraag?: Array<VragenDomainBetreftVraag>, options?: any) {
        return VraagAntwoordApiFp(this.configuration).vraagAntwoordGetSimpleFormatted(antwoordensetId, inclusiefVerborgenVragenMetBetreftVraag, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VraagVeldMappingsApi - axios parameter creator
 * @export
 */
export const VraagVeldMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Geeft een lijst met vraagveld mappings
         * @param {string} [productId] 
         * @param {Array<VragenDomainVraagVeldMappingSoort>} [soortMappings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagVeldMappingsGetVraagVeldMappings: async (productId?: string, soortMappings?: Array<VragenDomainVraagVeldMappingSoort>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (soortMappings) {
                localVarQueryParameter['soortMappings'] = soortMappings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VraagVeldMappingsApi - functional programming interface
 * @export
 */
export const VraagVeldMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VraagVeldMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Geeft een lijst met vraagveld mappings
         * @param {string} [productId] 
         * @param {Array<VragenDomainVraagVeldMappingSoort>} [soortMappings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vraagVeldMappingsGetVraagVeldMappings(productId?: string, soortMappings?: Array<VragenDomainVraagVeldMappingSoort>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vraagVeldMappingsGetVraagVeldMappings(productId, soortMappings, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VraagVeldMappingsApi - factory interface
 * @export
 */
export const VraagVeldMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VraagVeldMappingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Geeft een lijst met vraagveld mappings
         * @param {string} [productId] 
         * @param {Array<VragenDomainVraagVeldMappingSoort>} [soortMappings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vraagVeldMappingsGetVraagVeldMappings(productId?: string, soortMappings?: Array<VragenDomainVraagVeldMappingSoort>, options?: any): AxiosPromise<CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto> {
            return localVarFp.vraagVeldMappingsGetVraagVeldMappings(productId, soortMappings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VraagVeldMappingsApi - interface
 * @export
 * @interface VraagVeldMappingsApi
 */
export interface VraagVeldMappingsApiInterface {
    /**
     * 
     * @summary Geeft een lijst met vraagveld mappings
     * @param {string} [productId] 
     * @param {Array<VragenDomainVraagVeldMappingSoort>} [soortMappings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagVeldMappingsApiInterface
     */
    vraagVeldMappingsGetVraagVeldMappings(productId?: string, soortMappings?: Array<VragenDomainVraagVeldMappingSoort>, options?: any): AxiosPromise<CollectionResultOfVragenVraagVeldMappingsGetVraagVeldMappingsDto>;

}

/**
 * VraagVeldMappingsApi - object-oriented interface
 * @export
 * @class VraagVeldMappingsApi
 * @extends {BaseAPI}
 */
export class VraagVeldMappingsApi extends BaseAPI implements VraagVeldMappingsApiInterface {
    /**
     * 
     * @summary Geeft een lijst met vraagveld mappings
     * @param {string} [productId] 
     * @param {Array<VragenDomainVraagVeldMappingSoort>} [soortMappings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VraagVeldMappingsApi
     */
    public vraagVeldMappingsGetVraagVeldMappings(productId?: string, soortMappings?: Array<VragenDomainVraagVeldMappingSoort>, options?: any) {
        return VraagVeldMappingsApiFp(this.configuration).vraagVeldMappingsGetVraagVeldMappings(productId, soortMappings, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VragenApiApi - axios parameter creator
 * @export
 */
export const VragenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de mogelijke antwoorden terug voor een opgegeven lijst van vraagIds.
         * @param {Array<string>} [vraagIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vragenGetMogelijkeAntwoorden: async (vraagIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vragen/mogelijkeAntwoorden`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vraagIds) {
                localVarQueryParameter['vraagIds'] = vraagIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VragenApiApi - functional programming interface
 * @export
 */
export const VragenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VragenApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de mogelijke antwoorden terug voor een opgegeven lijst van vraagIds.
         * @param {Array<string>} [vraagIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vragenGetMogelijkeAntwoorden(vraagIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vragenGetMogelijkeAntwoorden(vraagIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VragenApiApi - factory interface
 * @export
 */
export const VragenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VragenApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
         * @summary Geeft de mogelijke antwoorden terug voor een opgegeven lijst van vraagIds.
         * @param {Array<string>} [vraagIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vragenGetMogelijkeAntwoorden(vraagIds?: Array<string>, options?: any): AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto> {
            return localVarFp.vragenGetMogelijkeAntwoorden(vraagIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VragenApiApi - interface
 * @export
 * @interface VragenApiApi
 */
export interface VragenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft de mogelijke antwoorden terug voor een opgegeven lijst van vraagIds.
     * @param {Array<string>} [vraagIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VragenApiApiInterface
     */
    vragenGetMogelijkeAntwoorden(vraagIds?: Array<string>, options?: any): AxiosPromise<Result1OfSystemCollectionsGenericDictionary2OfSUREbusinessCommonDomainTypedIdsVraagIdAndSystemCollectionsGenericList1OfVragenAntwoordOptiesAntwoordOptieDto>;

}

/**
 * VragenApiApi - object-oriented interface
 * @export
 * @class VragenApiApi
 * @extends {BaseAPI}
 */
export class VragenApiApi extends BaseAPI implements VragenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Vraag.ProductVragenInzien</li></ul>
     * @summary Geeft de mogelijke antwoorden terug voor een opgegeven lijst van vraagIds.
     * @param {Array<string>} [vraagIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VragenApiApi
     */
    public vragenGetMogelijkeAntwoorden(vraagIds?: Array<string>, options?: any) {
        return VragenApiApiFp(this.configuration).vragenGetMogelijkeAntwoorden(vraagIds, options).then((request) => request(this.axios, this.basePath));
    }
}


